import {Component, inject} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TableLazyLoadEvent, TableModule} from "primeng/table";
import {CardModule} from "primeng/card";
import {EbayService} from "@app/core/services";
import {EbayMarketplace} from "@app/core/interfaces/ebay";
import {BaseComponent} from "@app/core/bases";
import {BadgeModule} from "primeng/badge";
import {TooltipModule} from "primeng/tooltip";
import {Button} from "primeng/button";
import {EbayShopForm} from "@app/features/ebay/ebay-shop-form/ebay-shop-form";
import {DialogService} from "primeng/dynamicdialog";
import {ConfirmationService} from "primeng/api";

interface Column {
    field: string;
    header: string;
}

@Component({
    selector: 'app-ebay-shops',
    imports: [
        CommonModule,
        TableModule,
        CardModule,
        BadgeModule,
        TooltipModule,
        Button,
    ],
    providers: [ConfirmationService, DialogService],
    templateUrl: './ebay-shops.html'
})
export class EbayShops extends BaseComponent {
    ebayMarketplaces: EbayMarketplace[] = [];

    sort!: { field: string, order: number };
    cols: Column[] = [
        { field: 'nom', header: 'Nom' },
        { field: 'pays_code', header: 'Code Pays' },
        { field: 'langue', header: 'Langue' },
        { field: 'prefixe_sku', header: 'Préfixe SKU' },
        { field: 'devise', header: 'Devise' },
        { field: 'taux_change', header: 'Taux de change' },
        { field: 'tva_taux', header: 'Taux TVA' },
        { field: 'payment_policy_id', header: 'ID Politique de paiement' },
        { field: 'return_policy_id', header: 'ID Politique de retour' },
        { field: 'actif', header: 'Actif' },
    ];
    selectedColumns: Column[] = this.cols;
    expandedRows = {};

    isLoadingResults = true;
    isLoadedFromStorage = false;

    constructor(
        private dialogService: DialogService,
        private confirmationService: ConfirmationService,
        private ebayService: EbayService
    ) {
        super();
    }

    getTableEntries() {
        this.isLoadingResults = true;

        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.ebayService.getEbayMarketplace({
            order_by: this.sort?.field,
            order: this.sort?.order === 1 ? 'asc' : 'desc',
        }).subscribe({
            next: (data) => {
                this.ebayMarketplaces = data.results;
                this.isLoadingResults = false;
            },
            error: (error) => {
                console.error('Error fetching eBay marketplaces:', error);
                this.isLoadingResults = false;
            },
            complete: () => {
                this.apiCall$?.unsubscribe();
                this.isLoadingResults = false;
            }
        });
    }

    onLazyLoad(event: TableLazyLoadEvent) {
        this.sort = { field: event.sortField as string, order: event.sortOrder as number };
        this.getTableEntries();
    }

    onStateRestore(state: any) {
        this.isLoadedFromStorage = true;
    }

    getAspectsKeysValues(ebayMarketplace: EbayMarketplace): { key: string, value: string }[] {
        const aspectsKeyValue: { key: string, value: string }[] = [];

        if (ebayMarketplace.aspects_noms && Object.keys(ebayMarketplace.aspects_noms).length > 0) {
            for (const [key, value] of Object.entries(ebayMarketplace.aspects_noms)) {
                const existingIndex = aspectsKeyValue.findIndex(item => item.key === key);
                if (existingIndex !== -1) {
                    aspectsKeyValue[existingIndex].value = value[0];
                } else {
                    aspectsKeyValue.push({ key: key, value: value[0] });
                }
            }
        }
        return aspectsKeyValue;
    }

    showStockModal(ebayMarketplace: EbayMarketplace) {
        const data: any = {ebayMarketplace: ebayMarketplace};

        this.dialogRef = this.dialogService.open(EbayShopForm, {
            inputValues: data,
            width: '600px',
            modal: true,
            focusOnShow: false,
            header: `Modification de la boutique ${ebayMarketplace.nom}`
        });

        this.dialogRef?.onClose.subscribe((data: EbayMarketplace | null) => {
            if (data) {
                this.getTableEntries();
            }
        });
    }
}
